@if (feature(); as f) {
  <input
    class="ml-auto w-5 cursor-pointer appearance-none rounded-full border border-gray-500 text-transparent shadow-none outline-none"
    [colorPicker]="getColorInputValue(f)"
    [style.background]="getColorInputValue(f)"
    (colorPickerChange)="changeColorInputValue($event, f)"
    (colorPickerClose)="saveColorInputValue(f)"
  />
}
